import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetEventPageSlice,
  DeleteEventPageSlice,
} from "../../redux/features/EventPageManagementSlice";

const EventPageManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { list, pagination, loading } = useSelector(
    (state) => state?.EventPageManagement
  );

  const [page, setPage] = useState(1);
  const limit = 10;

  // Detect add page
  const isAddPage = useMatch("/EventPageManagement/AddEventPage");

  // Detect edit page (dynamic id)
  const isEditPage = useMatch("/EventPageManagement/EditEventPage/:id");

  // Show list only on main page
  const showList = !isAddPage && !isEditPage;

  useEffect(() => {
    if (showList) {
      dispatch(GetEventPageSlice({ page, limit }));
    }
  }, [dispatch, page, showList]);

  const handleEdit = (item) => {
    navigate(`/EventPageManagement/EditEventPage/${item._id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this event page?")) {
      dispatch(DeleteEventPageSlice(id));
    }
  };

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h2>Event Page Management</h2>
        </div>

        {showList && (
          <>
            <div className="d-flex justify-content-end mb-3">
              <NavLink to="AddEventPage" className="Button">
                <i className="fa fa-plus" /> Add Event Page
              </NavLink>
            </div>

            <div className="TableList">
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Title</th>
                    <th>Slug</th>
                    <th>H1 Title</th>
                    <th>Reviews</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan={8} style={{ textAlign: "center" }}>
                        Loading...
                      </td>
                    </tr>
                  )}

                  {!loading &&
                    list?.length > 0 &&
                    list?.map((item, index) => (
                      <tr key={item._id}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td>{item?.title}</td>
                        <td>{item?.slug}</td>
                        <td>{item?.h1Title}</td>
                        <td>{item?.reviews?.length || 0}</td>
                        <td>{item?.status}</td>
                        <td>{item?.createdAt?.substring(0, 10)}</td>
                        <td>
                          <div className="action-icons">
                            <i
                              className="fa fa-pencil edit-icon"
                              title="Edit"
                              onClick={() => handleEdit(item)}
                            />
                            <i
                              className="fa fa-trash delete-icon"
                              title="Delete"
                              onClick={() => handleDelete(item._id)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}

                  {!loading && list?.length === 0 && (
                    <tr>
                      <td colSpan={8} style={{ textAlign: "center" }}>
                        No Event Pages Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {pagination?.totalPages > 1 && (
                <div className="pagination mt-3">
                  <button
                    disabled={page === 1}
                    onClick={() => setPage((prev) => prev - 1)}
                  >
                    Prev
                  </button>

                  {[...Array(pagination?.totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={page === i + 1 ? "active" : ""}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    disabled={page === pagination?.totalPages}
                    onClick={() => setPage((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </>
        )}

        <Outlet />
      </div>
    </div>
  );
};

export default EventPageManagement;
